import React, { lazy } from 'react';
import { Section } from './ui/Section';
export function InstructorTestimonials() {
  return <Section className="bg-brand-bg" data-id="element-131">
      <div className="max-w-6xl mx-auto" data-id="element-132">
        {/* Title */}
        <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-3 text-[#8B0000]" data-id="element-133">
          🌍 Lo que dicen las instructoras que ya lo usan
        </h2>

        {/* Subtitle */}
        <p className="text-center text-brand-subtitle mb-12 text-sm font-body" data-id="element-134">
          Mensajes reales. Resultados reales.
        </p>

        {/* Image Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-135">
          {/* Gmail Collage */}
          <div className="flex flex-col" data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/r3yGbRz7szH2rdf7b4AS24/ChatGPT_Image_10_jun_2026,_09_20_29.webp" alt="Testimonios de instructoras por email" loading="lazy" decoding="async" className="w-full h-auto rounded-xl shadow-[0_4px_15px_rgba(0,0,0,0.10)]" data-id="element-137" />
            <p className="text-center text-brand-textMuted text-sm mt-4 font-body" data-id="element-138">
              📧 Testimonios por Email
            </p>
          </div>

          {/* Instagram Collage */}
          <div className="flex flex-col" data-id="element-139">
            <img src="https://cdn.magicpatterns.com/uploads/eU1nAzKHaZP5ojCd3C4FP3/ChatGPT_Image_10_jun_2026,_09_15_39.webp" alt="Testimonios de instructoras por Instagram" loading="lazy" decoding="async" className="w-full h-auto rounded-xl shadow-[0_4px_15px_rgba(0,0,0,0.10)]" data-id="element-140" />
            <p className="text-center text-brand-textMuted text-sm mt-4 font-body" data-id="element-141">
              📱 Testimonios por Instagram
            </p>
          </div>
        </div>

        {/* Closing Trust Line */}
        <div className="text-center" data-id="element-142">
          <div className="text-2xl mb-3" data-id="element-143">⭐⭐⭐⭐⭐</div>
          <p className="text-brand-subtitle font-body text-base md:text-lg font-medium" data-id="element-144">
            Más de 500 instructoras ya están transformando sus clases con el
            Sistema PRO.
          </p>
        </div>
      </div>
    </Section>;
}